import { IButtonStyles, mergeStyleSets } from '@fluentui/react';
import { baseColors } from '../../../../../theme';

export const classNames = mergeStyleSets({
  add: {
    flexShrink: 0,
  },
  wrap: {
    padding: '2px 8px 8px',
    marginBottom: 8,
    borderRadius: 4,
    border: `1px solid ${baseColors.inputBorder}`,
    selectors: {
      '&>button': {
        marginLeft: '8px!important',
      },
      '&>:first-child': {
        flexGrow: 1,
      },
    },
  },
});
export const btnStyles: IButtonStyles = {
  root: {
    color: baseColors.offBlack,
  },
  rootPressed: {
    color: baseColors.offBlack,
  },
};
